__turbopack_context__.v({
  "className": "silkscreen_78aad12d-module__GFJdPG__className",
});
